export const SET_PATIENT_BILLING_DETAILS = 'set_patient_billing_details'
export const RESET_SUPPORT_DASHBOARD = 'reset_support_dashboard'

export const initialSupportDashboardState: SupportDashboardState = {
  patientBillingDetails: null,
}
